import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import './InstallationLayout.css';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { grey } from '@mui/material/colors';
import Snackbar from '@mui/material/Snackbar';
import { makeStyles } from "@material-ui/core/styles";

import { validatePasscode, prepareProductData, initialDataSeed, serverRegistration, productInstall } from './Services';
import { fetchWhoAmI } from '../../Store/Slices/InstallationSlice';
import { userLogs, syncDatabase } from "../../Js/Common";
import { commonSliceActions } from '../../Store/Slices/CommonSlice';


const InstallationLayout = (props) => {
    const [installationType, setInstallationType] = useState('local');
    const [passcode, setPasscode] = useState('');
    const [productData, setProductData] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [success, setSuccess] = useState(false);
    const [webHostInstall, setWebHostInstall] = useState(false);

    const [stateSnackbar, setStateSnackbar] = useState({ modalopen: false, vertical: 'bottom', horizontal: 'center', snackbarMessage: '' });
    const { vertical, horizontal, modalopen, snackbarMessage } = stateSnackbar;
    const [isColorFlag, setIsColorFlag] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const classes = useStyles();
    const whoAmIData = useSelector(state => state.installation.whoAmIData);

    // [useEffect] : when passcode is verified and we get productData from CRM side call next related process like if error then set error message and if data is there then call next function 'initialDataSeed' to insert initial data

    useEffect(() => {
        const onProductDataUpdate = async () => {
            if (productData !== null) {
                let response = await prepareProductData(productData, whoAmIData, installationType);
                if (response !== true) {
                    setErrorMessage(response);
                }
                else {
                    let paramsObj = {
                        productInfo: productData.data.productInfo,
                        downloadopts: installationType,
                        customerInfo: productData.data.customerInfo,
                        userDefination: productData.data.userDefination,
                        userPermissions: productData.data.userPermissions,
                        whoami: whoAmIData
                    };

                    let mainObj = {
                        paramObj: paramsObj,
                        passcode: passcode
                    }
                    console.log("WWWWW", paramsObj);
                    let initialDataSeedComplete = await initialDataSeed(mainObj);
                    if (initialDataSeedComplete.status === 200) {
                        setSuccess(true);
                    }
                }
            }
        }
        onProductDataUpdate();

    }, [productData, whoAmIData, installationType, passcode]);

    // Function [checkPasscode] : Just to check passcode is valid or not and if not valid then set a error message  otherwise set 'productData' which we get in response

    const checkPasscode = async () => {
        console.log("whoAmIData",whoAmIData);

        let passcodeData = await validatePasscode(passcode);
        console.log("passcode", passcodeData);

        if (passcodeData.data.status === 200) {
            let customerInfo = passcodeData.data.customerInfo;
            let productInfo = passcodeData.data.productInfo;

            let webHostSyncFlag = false;
            if (webHostInstall == true) {
                console.log("HREER");
                let checkCustomer = await serverRegistration(customerInfo.customer_uuid);
                console.log("checkCustomer", checkCustomer);

                if (checkCustomer.data.status == 200) {
                    webHostSyncFlag = true;
                }
            }
            if (webHostSyncFlag == false) {
                setProductData(passcodeData);
            }
            else {
                let paramsObj = {
                    passcode: passcode,
                    customerInfo: customerInfo,
                    productInfo: productInfo,
                    whoAmIData: whoAmIData
                };
                await syncToWeb(paramsObj);
            }
        }
        else if (passcodeData.data.status === 400 || passcodeData.data.status === 500) {
            setErrorMessage('Invalid Passcode');
        }
    }

    const syncToWeb = async (paramsObj) => {
        dispatch(commonSliceActions.setLoader(true));
        let data = {};
        let params = {
            "init": true,
            "siteUuid": paramsObj.customerInfo.customer_uuid,
            "schoolName": paramsObj.customerInfo.customerName
        };

        let logsData = await syncDatabase(data, params);
        let logs = logsData.response;
        console.log("logs", logs);

        if (typeof logs == 'string') {
            setIsColorFlag(false);
            setStateSnackbar({ ...stateSnackbar, modalopen: true, snackbarMessage: logs });
        }
        else {
            await userLogs({
                verb: "sync",
                outcome: logs,
                site_uuid: paramsObj.customerInfo.customer_uuid
            });
            setIsColorFlag(true);
            setStateSnackbar({ ...stateSnackbar, modalopen: true, snackbarMessage: 'Sync Data Completed' });

            await productInstall(paramsObj);
            dispatch(commonSliceActions.setLoader(false));
        }
    };

    const handleClose1 = () => {
        setStateSnackbar({ ...stateSnackbar, modalopen: false });
    };

    const redirectToLogin = () => {
        dispatch(fetchWhoAmI());
        navigate('/');
    }

    return (
        <Grid container spacing={1} className='full-height'>
            <Grid item sm={12} md={5}>
                <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', p: 2, display: { xs: 'none', sm: 'none', md: 'block' } }} className='full-height'>
                    Image
                </Box>
            </Grid>
            <Grid item sm={12} md={7}>
                <Box sx={{ p: 1, textAlign: 'center' }}>
                    <img
                        src={require('../../assets/logo.png')}
                        alt='Vocablab'
                        loading="lazy"
                        width={128}
                    /><br />
                    <span style={{ fontSize: 40 }}>Installation</span><br />
                    <span style={{ fontSize: 20, fontStyle: 'italic', fontWeight: 100 }}>Enter your passcode and complete your installation.</span>
                    {success &&
                        <Box sx={{ pt: 5, px: 5, textAlign: 'center' }}>
                            <CheckCircleIcon sx={{ fontSize: 100, color: 'primary.success' }} /><br />
                            <Typography variant="h4" gutterBottom color="" component="div">
                                Completed!
                            </Typography>
                            <Button variant="contained" color='primary' sx={{ marginTop: 4 }} onClick={redirectToLogin}>Sign in</Button>
                        </Box>
                    }
                    {!success &&
                        <Box>
                            <Box sx={{ pt: 5, px: 5, textAlign: 'center' }}>
                                <TextField id="outlined-basic" label="Enter Passcode" variant="outlined" value={passcode} fullWidth onInput={(event) => { setPasscode(event.target.value) }} />
                            </Box>
                            <Box sx={{ pt: 5, px: 5, textAlign: 'left' }}>
                                <>
                                    <Select
                                        value={installationType}
                                        fullWidth
                                        onChange={(event) => { setInstallationType(event.target.value) }}
                                    >
                                        <MenuItem value={'local'} dense>Local</MenuItem>
                                        <MenuItem value={'web'} dense>Web</MenuItem>
                                    </Select>
                                    <Box>
                                        <FormControlLabel control={
                                            <Checkbox checked={webHostInstall} onChange={() => {
                                                setWebHostInstall(!webHostInstall)
                                            }}
                                                sx={{
                                                    color: grey[600],
                                                    '&.Mui-checked': {
                                                        color: grey[600],
                                                    },
                                                }} />
                                        } label="Web-Host Sync Data"
                                        />
                                    </Box>
                                </>
                            </Box>
                            {passcode !== null && passcode.trim() !== '' && productData !== null && productData.data.status === 200 && !errorMessage &&
                                <Box sx={{ pt: 5, px: 5, textAlign: 'center' }}>
                                    <Typography variant="h6" gutterBottom color="" component="div">
                                        Preparing...
                                    </Typography>
                                    <LinearProgress color='primary' />
                                </Box>
                            }
                            {errorMessage &&
                                <Box sx={{ pt: 5, px: 5, textAlign: 'center' }}>
                                    <Typography variant="h6" gutterBottom color="primary.error" component="div">
                                        {errorMessage}
                                    </Typography>
                                </Box>
                            }
                            {!(productData !== null && productData.data.status === 200 && !errorMessage) &&
                                <Box sx={{ pt: 5, px: 5, textAlign: 'center' }}>
                                    <Button variant="contained" fullWidth disabled={!(passcode !== null && passcode.trim() !== '')} onClick={checkPasscode}> Verify </Button>
                                </Box>
                            }
                        </Box>
                    }
                </Box>
            </Grid>
            {/* Snackbar or alert modal */}
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={2000}
                open={modalopen}
                onClose={handleClose1}
                message={snackbarMessage}
                key={vertical + horizontal}
                ContentProps={{
                    classes: {
                        root: isColorFlag ? classes.rootColor : classes.rootColor1
                    }
                }}
                sx={{ top: { xs: 90, sm: 0 } }}
            />
        </Grid>
    );
}

const useStyles = makeStyles({
    image: {
      width: '2.2rem',
      '@media (min-width: 1636px)': {
        width: '3rem',
      },
    },
    rootColor: {
      backgroundColor: 'lightgreen',
      color: 'black'
    },
    rootColor1: {
      backgroundColor: 'orange',
      color: 'black'
    },
    Modal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      height: '32vh',
      transform: 'translate(-50%, -50%)',
      width: 400,
      backgroundColor: '#DB8829',
      boxShadow: 24,
      color: '#FFFFFF',
      borderRadius: 30,
      padding: 20,
    }
});

export default InstallationLayout;